import React, { ReactNode } from 'react';
import { Virtuoso } from 'react-virtuoso';

interface Props {
    items: ReactNode[];
}

const SupervisorList = ({ items }: Props) => (
    <Virtuoso
        className="scrollbar focus-ring-inset grow"
        // Virtuoso puts `outline: none` inline on its scroller, which is a
        // Tab stop; an undefined outline drops it, so the focus ring shows.
        style={{ outline: undefined }}
        data={items}
        overscan={7}
        itemContent={(index, item) => (
            <div key={`sl-item-${index}`}>{item}</div>
        )}
    />
);

export default SupervisorList;
